import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';
import Image from '../../Image';
import RichText from '../../RichText';

const MEDIA_SIZE = '544px';
const MEDIA_SIZE_TABLET = '360px';
const MEDIA_SIZE_MOBILE = '344px';
const TRIANGLE_HEIGHT_MOBILE = '439px';
const TRIANGLE_HEIGHT_TABLET = '508px';
const TRIANGLE_MIN_HEIGHT = '248px';
const TRIANGLE_MAX_HEIGHT = '368px';
const TRIANGLE_MAX_HEIGHT_WITH_MEDIA = '640px';

export const Container = styled.div`
  /* allows div to overlay */
  display: grid;
  isolation: isolate;
`;

export const TriangleContainer = styled.div<{ hasMedia: boolean; hideTriangle: boolean }>`
  /* positions this element full width outside the grid */
  margin: 0 calc(50% - 50vw);
  z-index: -1;
  display: ${({ hasMedia }) => (hasMedia ? 'block' : 'none')};
  background-color: ${({ hideTriangle, theme }) =>
    hideTriangle ? 'transparent' : `${colors.core02({ theme })}`};
  clip-path: polygon(18% 0%, 100% 0%, 100% 100%);
  grid-row-start: 1;
  grid-column-start: 1;
  height: ${TRIANGLE_HEIGHT_MOBILE};

  ${mediaQuery.tabletPortrait`
    clip-path: polygon(20% 0%, 100% 0%, 100% 100%);
    height: ${TRIANGLE_HEIGHT_TABLET};
  `}

  ${mediaQuery.tabletLandscape`
    clip-path: polygon(60% 0%, 100% 0%, 100% 100%);
    display: block;
    height: auto;
    min-height: ${TRIANGLE_MIN_HEIGHT};
    max-height: ${({ hasMedia }) =>
      hasMedia ? `${TRIANGLE_MAX_HEIGHT_WITH_MEDIA}` : `${TRIANGLE_MAX_HEIGHT}`}
    
  `}
`;

export const ReversibleGrid = styled(Grid)<{ hasMedia: boolean }>`
  grid-row-start: 1;
  grid-column-start: 1;
  display: flex;
  flex-flow: column-reverse;

  /* allow the triangle to be longer than text/media */
  padding-bottom: ${spacing(4)};

  ${({ hasMedia }) => mediaQuery.tabletLandscape`
    flex-flow: row;
    padding-bottom: ${hasMedia ? spacing(4) : spacing(8)};
  `}
`;

export const MediaContainer = styled.div`
  grid-row-start: 1;
  grid-column-start: 1;

  ${mediaQuery.tabletLandscape`
    padding-right: ${spacing(0)};
    padding-top: ${spacing(7)}
  `}
`;

export const MediaWrapper = styled.figure`
  margin-left: auto;
  margin-top: auto;
  max-width: ${MEDIA_SIZE_MOBILE};
  padding: ${spacing(5)} 0 0;
  ${mediaQuery.tabletPortrait`
    max-width: ${MEDIA_SIZE_TABLET};
    padding: ${spacing(8)} 0 0;
  `}
  ${mediaQuery.tabletLandscape`
    max-width: ${MEDIA_SIZE};
    padding: 0;
  `}
`;

export const OptionalCaption = styled.figcaption`
  ${fonts.paragraph}
`;

export const MainImage = styled(Image)``;

export const Heading = styled.h1<{ hasMedia?: boolean }>`
  ${fonts.headingLarge}

  margin-bottom: ${spacing(2)};
  margin-top: ${spacing(5)};
  ${mediaQuery.tabletPortrait`
    margin-top: ${({ hasMedia }) => (hasMedia ? spacing(5) : spacing(8))};
  `}

  & {
    color: ${colors.core01};
    font-weight: 500;
    font-size: ${({ hasMedia }) => (hasMedia ? '52px' : '72px')};
    line-height: ${({ hasMedia }) => (hasMedia ? '60px' : '80px')};
    ${mediaQuery.tabletPortrait`
      ${fonts.headingXLarge}
    `}
  }
`;

export const Subhead = styled.p`
  ${fonts.headingSmall}
  margin: 0;

  & {
    color: ${colors.neutral01};
    font-weight: 500;
  }
`;

export const Body = styled(RichText)`
  ${fonts.paragraph}
  margin: ${spacing(2)} 0 0;

  & {
    color: ${colors.neutral01};
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
